import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Accueil from '../pages/Accueil';
import Recettes from '../pages/Recettes';
import Contact from '../pages/Contact';
import Science from '../components/Science';
import Quiz from '../components/Quiz';
import PeriodicTable from '../components/PeriodicTable';
import MoleculeBuilder from '../components/MoleculeBuilder';
import Footer from './Footer';
import '../Style/App.css';

function App() {
  // Etat pour gérer l'affichage du menu burger
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Fonction pour toggler l'état du menu burger
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Fonction pour fermer le menu lorsque l'utilisateur clique sur un lien
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <Router>
      <div className="App">
        <nav className={`navbar ${isMenuOpen ? 'open' : ''}`}>
          {/* Logo placé à gauche */}
          <div className="logo-container">
            <Link to="/" className="logo">
              <img src="/images/logo.png" alt="Logo de l'application" />
            </Link>
          </div>

          {/* Icône hamburger */}
          <div className="hamburger" onClick={toggleMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>

          {/* Liste de navigation */}
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={closeMenu}>Accueil</Link></li>
            <li><Link to="/recettes" onClick={closeMenu}>Recettes</Link></li>
            <li><Link to="/science" onClick={closeMenu}>Science des Pâtisseries</Link></li>
            <li><Link to="/quiz" onClick={closeMenu}>Quiz</Link></li>
            <li><Link to="/periodic-table" onClick={closeMenu}>Tableau Périodique</Link></li>
            <li><Link to="/molecule-builder" onClick={closeMenu}>Constructeur de Molécules</Link></li>
            <li className="contact-item"><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
          </ul>
        </nav>

        <main>
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/recettes" element={<Recettes />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/science" element={<Science />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/periodic-table" element={<PeriodicTable />} />
            <Route path="/molecule-builder" element={<MoleculeBuilder />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
